



















import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({
    components: {
        InputNumber: InputNumber
    },
    data: function() {
        return {
            pathInStore: "transaction.certificates.primaryEnergyConsumption.yearlyTheoreticalTotal",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "APARTMENT", "GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        yearlyTheoreticalTotal: function(): string|null {
            const yearlyTheoritical = this.$store.getters["FormModule/getValue"](this.pathInStore);
            if(yearlyTheoritical) {
                return yearlyTheoritical;
            }
            return "";
        },
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(yearlyTheoreticalTotal: number): void {
            if (yearlyTheoreticalTotal == 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": yearlyTheoreticalTotal});
            }
        },
    },
});
